import React, { useContext } from 'react';
import { Pager } from '../Pager/Pager.component';
import { QAResultContent } from '../QAResultContent/QAResultContent';
import { useSEO } from './useSEO';
import QAContext from '../../context/QAContext';
import { useQAResult } from './useQAResult';
import { dataModel } from '../dataModel';
import { QAResultHeader } from './QAResultHeader';

export const QAResultMobile = () => {
  let{
    TotalResults, Results, searchText, seoPageNumber
  } = useContext(QAContext);

  const qaResult = useQAResult();
  const { seoResults, seoAnswers, seoTotalResults } = useSEO(qaResult);

  const showResults = !!(Results?.length || seoResults?.length || !searchText);

  const showPager = (Results?.length > 0 || qaResult);

  return (
    <>
      <QAResultHeader seoTotalResults={seoTotalResults} seoResults={seoResults} />
      {showResults && (
        <div>
          <QAResultContent
            seoResults={seoResults}
            seoAnswers={seoAnswers}
            seoTotalResults={seoTotalResults}
          />
          {showPager && (
            <div className="sui-w-full">
              {(TotalResults || seoTotalResults) > 8 && (
                <div className="sui-mb-4">
                  <Pager seoTotalResults={seoTotalResults} seoPageNumber={seoPageNumber} />
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

QAResultMobile.displayName = 'QAResultMobile';

QAResultMobile.dataModel = dataModel;
